<form *ngIf="regroupementPlat" (ngSubmit)="saveRegroupementPlat()" #regroupementPlatForm="ngForm">
  <div class="dialog-line">
    <div class="custom-button-container-right save-container">
      <yo-button
        [disabled]="!canSave() && !regroupementPlatForm.valid "
        iconClass="fas fa-save"
        (onClick)="saveRegroupementPlat()"
        tooltip="Enregistrer"
        [theme]="ButtonThemeEnum.SUCCESS">
      </yo-button>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label" title="site">Site <span class="danger-color">*</span></div>
    <div class="value">
      <yo-lookup
        #siteLookup
        [disabled]="regroupementPlat.id !== 0"
        [data]="sitesList"
        [selectedItem]="selectedSite"
        (onValueChange)="updateSelectedSite($event)"
      >
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label" title="Libellé">Libellé <span class="danger-color">*</span></div>
    <div class="value">
      <dx-text-box
        required
        [readOnly]="!canEdit()"
        class='inputfield'
        [(ngModel)]="regroupementPlat.libelle"
        #libelle="ngModel"
        name="libelle"
      >
      </dx-text-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label" title="Libellé">Unités de production<span class="danger-color">*</span></div>
    <div class="value">
      <yo-tagbox
        #udpList
        [data]="unitesDeProductionList"
        [selectedItems]="selectedUdp"
        [disabled]="!canEdit()"
        (onValueChange)="updateUdpList($event)"
        placeholder="Unité de production">
      </yo-tagbox>
    </div>
  </div>
</form>
